import React, { useEffect, useRef } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
// import FormSelectionField from "../../components/formFields/FormSelectionField";
// import { STATUSARRAY } from "../../_contstants/common";
import {
  createGallery,
  getAllGallerys,
  getGalleryByID,
  updateGallery,
} from "./services/gallery.services";
import { clearGalleryDetails } from "./gallerySlice";
import { RxCross1 } from "react-icons/rx";
import FormImageUpload from "../../components/formFields/FormImageUpload";
import IconButton from "../../components/common/IconButton";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { closed } from "../../components/muidrawer/muiDrawerSlice";

const CreateGallery: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const GalleryID = useAppSelector((state) => state.muidrawer.data);
  const GalleryDetail = useAppSelector((state) => state.gallery.GalleryDetail);
  const loading = useAppSelector((state) => state.gallery.formLoading);
  const [formKey, setFormKey] = React.useState(1);

  useEffect(() => {
    if (GalleryID) {
      dispatch(getGalleryByID(GalleryID));
    }
    return () => {
      dispatch(clearGalleryDetails());
    };
  }, [GalleryID]);

  useEffect(() => {
    return () => {
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [GalleryDetail]);

  const handleSubmit = async (values: any) => {
    const ImageType = values?.ImageType ? values?.ImageType : "";
    const ImgAlt = values?.ImgAlt ? values?.ImgAlt : "";
    const ImageData = new FormData();
    const OtherImageFiles = values.OtherImageFiles?.map((fileItem: any) =>
      fileItem.getRawFile ? fileItem.getRawFile() : fileItem,
    );

    try {
      if (GalleryID) {
        if (
          values?.OtherImageFiles &&
          typeof values?.OtherImageFiles !== "string"
        ) {
          OtherImageFiles?.map((image: any) =>
            ImageData.append("OtherImageFiles", image),
          );
          ImageData.append("ImageType", ImageType);
          ImageData.append("ID", GalleryID);
          const response = await dispatch(updateGallery(ImageData));
          if (response?.meta?.requestStatus === "fulfilled") {
            dispatch(closed());
            dispatch(getAllGallerys());
            dispatch(clearGalleryDetails());
          }
        }
      } else {
        if (
          values?.OtherImageFiles &&
          typeof values?.OtherImageFiles !== "string"
        ) {
          ImageData.append("ImageType", ImageType);
          ImageData.append("ImgAlt", ImgAlt);

          OtherImageFiles?.map((image: any) =>
            ImageData.append("OtherImageFiles", image),
          );
          const response = await dispatch(createGallery(ImageData));
          if (response?.meta?.requestStatus === "fulfilled") {
            dispatch(closed());
            dispatch(getAllGallerys());
            dispatch(clearGalleryDetails());
          }
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <div>
        <Form
          key={formKey}
          onSubmit={handleSubmit}
          initialValues={GalleryDetail}
          render={(formRenderProps: FormRenderProps) => (
            <FormElement>
              <GridLayout gap={{ rows: 0, cols: 0 }} cols={[{ width: "100%" }]}>
                <GridLayoutItem className="master-drawer-header">
                  <Typography.h4 className="m-0">
                    {GalleryID ? "Update Gallery" : "Create Gallery"}
                  </Typography.h4>
                  <IconButton
                    type="button"
                    fillMode={"flat"}
                    themeColor={"dark"}
                    style={{ marginRight: 4 }}
                    onClick={() => dispatch(closed())}
                  >
                    <RxCross1 />
                  </IconButton>
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    id={"ImageType"}
                    name={"ImageType"}
                    label={"Image Type"}
                    placeholder="Select image type"
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={[
                      { value: "Retailers", label: "Retailers" },
                      { value: "Homeowners", label: "Homeowners" },
                    ]}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    justifyContent="start"
                    name="OtherImageFiles"
                    label="Images"
                    type="file"
                    accept="image/*"
                    alternateName="Images"
                    multiple={true}
                    component={FormImageUpload}
                  />
                </GridLayoutItem>

                <GridLayoutItem
                  style={{
                    marginTop: "20px",
                  }}
                >
                  <div>
                    <ButtonWithLoading
                      label={GalleryID ? "Update" : "Create"}
                      type="submit"
                      disabled={!formRenderProps.allowSubmit || loading}
                      loading={loading}
                    />
                    <Button
                      type="button"
                      fillMode={"outline"}
                      themeColor={"primary"}
                      style={{ marginLeft: 10 }}
                      onClick={() => dispatch(closed())}
                    >
                      Cancel
                    </Button>
                  </div>
                </GridLayoutItem>
              </GridLayout>
            </FormElement>
          )}
        />
      </div>
    </>
  );
};

export default CreateGallery;
